module.exports = __webpack_public_path__ + "static/media/logo_cavca_blanco.f87edf0d.png";